function message () {
  return {
    application: {
      title: 'Shopee Taiwan 東南亞新二代扶持計畫',
      desc: '蝦皮購物東南亞新二代扶持計畫是針對全台東南亞新住民二代特別推出的專屬計畫，招募對象為台灣東南亞新二代大專院校學生，提供舞台使其展現創意力，協助推進好想法及富含多元文化的好點子！2023年度計畫包含【社會共好創意提案】及【社群推廣新星徵選】兩大項目，目的是讓東南亞新二代學子能運用跨國背景，提出環境永續、消弭文化差異等主題之提案，共同與蝦皮購物創造社會共好，並透過實際落地執行，培養學子邏輯思維能力，以利銜接浩瀚職涯未來。',
      startDate: '15 September 2023',
      endDate: '31 October 2023'
    },
    navbar: [{
      text: 'nsgs_nav_about',
      href: '/about',
      target: '_blank'
    }, {
      text: 'nsgs_nav_why_shopee',
      href: '/why-shopee',
      target: '_blank'
    }, {
      text: 'nsgs_nav_work',
      href: '/jobs',
      target: '_blank'
    }, {
      text: 'nsgs_nav_student',
      href: '/students',
      target: '_blank'
    }, {
      text: 'nsgs_nav_tech',
      href: '/tech',
      target: '_blank'
    }, {
      text: 'nsgs_nav_event',
      href: '/recruitment-event',
      target: '_blank'
    }],
    subNavbar: [
      {
        text: 'nsgs_nav_about_scholarship',
        href: '#about'
      },
      {
        text: 'nsgs_nav_apply',
        href: '#apply'
      },
      {
        text: 'nsgs_nav_time',
        href: '#time'
      },
      {
        text: 'nsgs_nav_application_data',
        href: '#required'
      },
      {
        text: 'nsgs_nav_faq',
        href: '#faq'
      },
    ],
    banner: {
      title: 'nsgs_banner_intro_title',
      introDesc: 'nsgs_banner_intro_desc',
      applyText: 'nsgs_banner_apply_text',
      applyNum: 'nsgs_banner_apply_num',
      applyUnit: 'nsgs_banner_apply_num_unit',
      awardText: 'nsgs_banner_award_text',
      awardNum: 'nsgs_banner_award_num',
      awardUnit: 'nsgs_banner_award_num_unit',
    },
    about: {
      title: 'nsgs_about_title',
      desc: 'nsgs_about_desc',
      subDesc: 'nsgs_about_desc_2',
      list: [
        {
          image: require('@nsgscholarship/assets/images/about-1-2023.jpg'),
          introTitle: 'nsgs_about_merit_scholarship_intro_title',
          introDesc: 'nsgs_about_merit_scholarship_intro_desc',
          tips: [
            {
              icon: require('@nsgscholarship/assets/icons/tip-6.svg'),
              text: 'nsgs_about_merit_scholarship_tip_1'
            },
            {
              icon: require('@nsgscholarship/assets/icons/tip-4.svg'),
              text: 'nsgs_about_merit_scholarship_tip_2'
            },
            {
              icon: require('@nsgscholarship/assets/icons/tip-5.svg'),
              text: 'nsgs_about_merit_scholarship_tip_3'
            },
            {
              icon: require('@nsgscholarship/assets/icons/tip-2.svg'),
              text: 'nsgs_about_merit_scholarship_tip_4'
            }
          ]
        },
        {
          image: require('@nsgscholarship/assets/images/about-2-2023.jpg'),
          introTitle: 'nsgs_about_welfare_scholarship_intro_title',
          introDesc: 'nsgs_about_welfare_scholarship_intro_desc',
          tips: [
            {
              icon: require('@nsgscholarship/assets/icons/tip-6.svg'),
              text: 'nsgs_about_welfare_scholarship_tip_1'
            },
            {
              icon: require('@nsgscholarship/assets/icons/tip-2.svg'),
              text: 'nsgs_about_welfare_scholarship_tip_2'
            }
          ]
        }
      ],
      explains: [
        'nsgs_about_explain_1', 'nsgs_about_explain_2','nsgs_about_explain_3','nsgs_about_explain_4','nsgs_about_explain_5',
      ]
    },
    apply: {
      title: 'nsgs_apply_title',
      list: [
        {
          icon: require('@nsgscholarship/assets/icons/apply-1.svg'),
          title: 'nsgs_apply_merit_scholarship_title',
          descs: [
            'nsgs_apply_merit_scholarship_desc_1',
            'nsgs_apply_merit_scholarship_desc_2',
            // 'nsgs_apply_merit_scholarship_desc_3'
          ]
        },
        {
          icon: require('@nsgscholarship/assets/icons/apply-2.svg'),
          title: 'nsgs_apply_welfare_scholarship_title',
          descs: [
            'nsgs_apply_welfare_scholarship_desc_1',
            'nsgs_apply_welfare_scholarship_desc_2',
            'nsgs_apply_welfare_scholarship_desc_3'
          ]
        }
      ],
      explains: [
        'nsgs_apply_explain_1', 'nsgs_apply_explain_2', 'nsgs_apply_explain_3'
      ]
    },
    time: {
      title: 'nsgs_time_title',
      list: [
        {
          icon: require('@nsgscholarship/assets/images/time-1-2023.png'),
          date: 'nsgs_time_apply_date',
          text: 'nsgs_time_apply_text',
          title: 'nsgs_time_title_1',
        },
        {
          icon: require('@nsgscholarship/assets/images/time-2-2023.png'),
          date: 'nsgs_time_audit_date',
          text: 'nsgs_time_audit_text',
          title: 'nsgs_time_title_2',
        },
        {
          icon: require('@nsgscholarship/assets/images/time-3-2023.png'),
          date: 'nsgs_time_notice_date_3',
          text: 'nsgs_time_notice_text_3',
          title: 'nsgs_time_title_3',
        },
        {
          icon: require('@nsgscholarship/assets/images/time-4-2023.png'),
          date: 'nsgs_time_notice_date_4',
          text: 'nsgs_time_notice_text_4',
          title: 'nsgs_time_title_4',
          tips: 'nsgs_time_notice_tips_4',
        },
        {
          icon: require('@nsgscholarship/assets/images/time-5-2023.png'),
          date: 'nsgs_time_notice_date_5',
          text: 'nsgs_time_notice_text_5',
          title: 'nsgs_time_title_5',
        }
      ],
      explains: [
        'nsgs_time_explain_1', 'nsgs_time_explain_2'
      ]
    },
    requiredInfo: {
      title: 'nsgs_required_info_title',
      desc: 'nsgs_required_info_desc',
      list: [
        {
          title: 'nsgs_required_info_list_item_title_1',
          desc: 'nsgs_required_info_list_item_desc_1'
        },
        {
          title: 'nsgs_required_info_list_item_title_2',
          desc: 'nsgs_required_info_list_item_desc_2'
        },
        {
          title: 'nsgs_required_info_list_item_title_3',
          desc: 'nsgs_required_info_list_item_desc_3'
        },
        {
          title: 'nsgs_required_info_list_item_title_4',
          desc: 'nsgs_required_info_list_item_desc_4'
        },
        {
          title: 'nsgs_required_info_list_item_title_5',
          desc: 'nsgs_required_info_list_item_desc_5'
        },
        {
          title: 'nsgs_required_info_list_item_title_6',
          desc: 'nsgs_required_info_list_item_desc_6'
        }
      ],
      explains: [
        // 'nsgs_required_info_explain_1', 'nsgs_required_info_explain_2', 'nsgs_required_info_explain_3'
      ]
    }, 
    faq: {
      title: 'nsgs_faq_title',
      list: [
        {
          question: 'nsgs_faq_question_1',
          answer: 'nsgs_faq_answer_1'
        },
        {
          question: 'nsgs_faq_question_2',
          answer: 'nsgs_faq_answer_2'
        },
        {
          question: 'nsgs_faq_question_3',
          answer: 'nsgs_faq_answer_3'
        },
        {
          question: 'nsgs_faq_question_4',
          answer: 'nsgs_faq_answer_4'
        },
        {
          question: 'nsgs_faq_question_5',
          answer: 'nsgs_faq_answer_5'
        },
        {
          question: 'nsgs_faq_question_6',
          answer: 'nsgs_faq_answer_6'
        }
      ],
      contact: {
        title: 'nsgs_faq_contact_us_title',
        text: 'nsgs_faq_contact_us_text'
      }
    },
    stageTwo: {
      title: 'nsgs_stage_two_title',
      desc: 'nsgs_stage_two_desc',
      descTwo: 'nsgs_stage_two_desc_2',
      list: [
        {
          icon: require('@nsgscholarship/assets/icons/apply-1.svg'),
          title: 'nsgs_stage_two_item_title_1',
          detail: [
            {
              icon: require('@nsgscholarship/assets/icons/green-stars.svg'),
              title: 'nsgs_stage_two_theme_title_1_1',
              subTitle: 'nsgs_stage_two_theme_title_1_1_desc_1',
              // desc: ['nsgs_stage_two_theme_title_1_1_desc_1']
              desc: []
            },
            {
              icon: require('@nsgscholarship/assets/icons/green-stars.svg'),
              title: 'nsgs_stage_two_theme_title_1_2',
              subTitle: 'nsgs_stage_two_theme_sub_title_1_2',
              desc: ['nsgs_stage_two_theme_title_1_2_desc_1', 'nsgs_stage_two_theme_title_1_2_desc_2']
            }
          ]
        },
        {
          icon: require('@nsgscholarship/assets/icons/apply-2.svg'),
          title: 'nsgs_stage_two_item_title_2',
          detail: [
            {
              icon: require('@nsgscholarship/assets/icons/yellow-stars.svg'),
              title: 'nsgs_stage_two_theme_title_2_1',
              subTitle: 'nsgs_stage_two_theme_title_2_1_desc_1',
              desc: []
            },
            {
              icon: require('@nsgscholarship/assets/icons/yellow-stars.svg'),
              title: 'nsgs_stage_two_theme_title_2_2',
              desc: ['nsgs_stage_two_theme_title_2_2_desc_1', 'nsgs_stage_two_theme_title_2_2_desc_2']
            }
          ]
        },
      ],
      explains: [
        'nsgs_stage_two_explain_1', 'nsgs_stage_two_explain_2', 'nsgs_stage_two_explain_3'
      ]
    }, 
    attention: {
      title: 'nsgs_attention_title',
      moreBtn: 'nsgs_attention_more_btn',
      list: [
        'nsgs_attention_item_1', 'nsgs_attention_item_2', 'nsgs_attention_item_3','nsgs_attention_item_4','nsgs_attention_item_5','nsgs_attention_item_6','nsgs_attention_item_7','nsgs_attention_item_8', 'nsgs_attention_item_9', 'nsgs_attention_item_10','nsgs_attention_item_11','nsgs_attention_item_12','nsgs_attention_item_13','nsgs_attention_item_14'
      ]
    },
    footer: {
      follow: 'nsgs_footer_follow_us',
      letterMessage: 'nsgs_footer_letter_message',
      career: 'nsgs_footer_shopee_career',
      more: 'nsgs_footer_more',
      social: [{
        href: 'https://www.linkedin.com/company/shopee/',
        name: 'linkin',
        icon: require('@nsgscholarship/assets/icons/linkedin.svg')
      }, {
        href: 'https://www.facebook.com/shopeecareers.tw/',
        name: 'facebook',
        icon: require('@nsgscholarship/assets/icons/facebook.svg')
      }, {
        href: 'https://www.instagram.com/shopeecareerstw/',
        name: 'instagram',
        icon: require('@nsgscholarship/assets/icons/instagram.svg')
      }, {
        href: 'https://shopee.sg/blog/category/shopee-careers-lifeatshopee/',
        name: 'blog',
        icon: require('@nsgscholarship/assets/icons/shopee-blog.svg')
      }, {
        href: 'https://youtube.com/playlist?list=PLw-SfklDWGE0ca8OWL4eP-asvDaUEiDlB',
        name: 'youtube',
        icon: require('@nsgscholarship/assets/icons/youtube.svg')
      }],
      websiteLinks: [
        {
          text: 'nsgs_footer_home',
          href: '/'
        },
        {
          text: 'nsgs_footer_about',
          href: '/about',
        },
        {
          text: 'nsgs_footer_life_at_shopee',
          href: 'https://shopee.sg/blog/category/shopee-careers-lifeatshopee/'
        },
        {
          text: 'nsgs_footer_event',
          href: '/recruitment-event'
        },
        {
          text: 'nsgs_footer_job',
          href: '/jobs'
        },
        {
          text: 'nsgs_footer_student',
          href: '/students'
        },
        {
          text: 'nsgs_footer_tech',
          href: '/tech'
        }
      ],
      otherLinks: [
        {
          text: 'nsgs_footer_sea',
          href: 'https://www.sea.com/home'
        },
        {
          text: 'nsgs_footer_garena',
          href: 'https://www.garena.sg/'
        },
        {
          text: 'nsgs_footer_seamoney',
          href: 'https://www.seamoney.com/'
        }
      ],
      copyright: 'nsgs_footer_copyright',
      privacyPolicy: 'https://careers.shopee.tw/privacy-policy',
      privacyPolicyText: 'nsgs_footer_pp_text',
      tc: 'https://careers.shopee.tw/terms-of-service',
      tcText: 'nsgs_footer_tc_text',
    }
  }
}

export default message